module.exports = __webpack_public_path__ + "75da69ba03892e3694331204c96ddd72.svg";